// src/utils/lineTax.js — GENERATED from functions/utils/lineTax.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildLineTaxCopies.js   (taxlines-771ce983)
// src/utils/lineTax.test.js fails if this file is not exactly what the generator writes.
// What these rules do and why: see the header of functions/utils/lineTax.js.

/* eslint-disable */

// LINETAX-BODY-START
var LINE_TAX_MARKER = 'taxlines-771ce983';
var NO_TAX = 'none'; // the picker's value for "No tax (exempt)"
var NO_TAX_LABEL = 'No tax (exempt)';
var STOPPED_NOTE = 'This code is no longer used. New lines can’t pick it.';
var LEGACY_TAX_CODES_ORG_IDS = ['YqmfHuIhV5fOlp0YFc2y']; // on before the switch became a setting (Spatchy Test Company)

/** Is Settings › Taxes on for this company? taxCodesDoc = organizations/{org}/settings/taxCodes, or null. */
function taxCodesSwitchOn(orgId, taxCodesDoc) {
  var d = taxCodesDoc;
  if (d && typeof d === 'object' && typeof d.enabled === 'boolean') return d.enabled;
  return typeof orgId === 'string' && LEGACY_TAX_CODES_ORG_IDS.indexOf(orgId) !== -1;
}

/** The saved codes, or null when none have been saved yet (the doc is missing or holds only the switch). */
function savedTaxCodes(taxCodesDoc) {
  return taxCodesDoc && Array.isArray(taxCodesDoc.codes) ? taxCodesDoc.codes : null;
}

// ── parts ─────────────────────────────────────────────────────────────────────────────────

/** A part's name for matching: trimmed, inner spaces collapsed, lower case. "  GST " → "gst". */
function normTaxPartName(name) {
  return String(name === null || name === undefined ? '' : name).trim().replace(/\s+/g, ' ').toLowerCase();
}

/** "GST" at 5 is the same tax wherever it appears: one key, so totals show ONE "GST 5%" row. */
function taxPartKey(name, rate) {
  var n = Number(rate);
  return 'part:' + normTaxPartName(name) + '@' + (Number.isFinite(n) ? String(Math.round(n * 1000) / 1000) : '0');
}

function isCodeObject(c) {
  return c !== null && typeof c === 'object' && typeof c.id === 'string' && c.id !== '' && Array.isArray(c.parts) && c.parts.length > 0;
}

function namedCodeById(codes, id) {
  if (typeof id !== 'string' || id === '') return null;
  var list = Array.isArray(codes) ? codes : [];
  for (var i = 0; i < list.length; i++) if (isCodeObject(list[i]) && list[i].id === id) return list[i];
  return null;
}

/** The code new lines get: the one marked default and still in use. */
function defaultNamedCode(codes) {
  var list = Array.isArray(codes) ? codes : [];
  for (var i = 0; i < list.length; i++) {
    if (isCodeObject(list[i]) && list[i].isDefault === true && list[i].stopped !== true) return list[i];
  }
  return null;
}

/** The copy of a code a line keeps: only names and rates (no ids, stamps or flags). */
function salesTaxSnapshotOf(code) {
  return {
    codeId: code.id,
    name: String(code.name || ''),
    parts: code.parts.map(function (p) { return { name: String((p && p.name) || ''), rate: Number(p && p.rate) || 0 }; }),
  };
}

function snapshotFits(line, id) {
  var s = line && line.salesTaxSnapshot;
  return !!(s && typeof s === 'object' && s.codeId === id && Array.isArray(s.parts) && s.parts.length > 0);
}

// ── what a line shows ────────────────────────────────────────────────────────────────────────

/**
 * The picker's current value for a line, and why:
 *   { value: NO_TAX | codeId | '', code, name, stopped, fromDefault, missing, note }
 * fromDefault = an old line with no code, shown as the default. missing = the code is gone from
 * the list (never deleted, so only for odd data) — shown by its kept copy's name.
 */
function lineTaxStatus(line, codes) {
  var l = line || {};
  if (l.taxExempt === true) return { value: NO_TAX, code: null, name: NO_TAX_LABEL, stopped: false, fromDefault: false, missing: false, note: '' };
  var id = typeof l.salesTaxCodeId === 'string' ? l.salesTaxCodeId : '';
  if (id) {
    var code = namedCodeById(codes, id);
    if (code) {
      var stopped = code.stopped === true;
      return { value: id, code: code, name: code.name, stopped: stopped, fromDefault: false, missing: false, note: stopped ? STOPPED_NOTE : '' };
    }
    var kept = snapshotFits(l, id) ? l.salesTaxSnapshot.name : '';
    return { value: id, code: null, name: kept || 'Tax', stopped: true, fromDefault: false, missing: true, note: STOPPED_NOTE };
  }
  var d = defaultNamedCode(codes);
  return { value: d ? d.id : '', code: d, name: d ? d.name : '', stopped: false, fromDefault: true, missing: false, note: '' };
}

/**
 * The picker's choices for one line: every code in use (the default first), the line's own
 * stopped code if it has one (marked), then "No tax (exempt)".
 *   [{ value, label, name, stopped, isDefault }]
 */
function lineTaxChoices(codes, line) {
  var list = (Array.isArray(codes) ? codes : []).filter(isCodeObject);
  var status = lineTaxStatus(line, list);
  var out = [];
  var inUse = list.filter(function (c) { return c.stopped !== true; });
  inUse.sort(function (a, b) { return (b.isDefault === true ? 1 : 0) - (a.isDefault === true ? 1 : 0); });
  inUse.forEach(function (c) {
    out.push({ value: c.id, label: c.isDefault === true ? c.name + ' (default)' : c.name, name: c.name, stopped: false, isDefault: c.isDefault === true });
  });
  if (status.value && status.value !== NO_TAX && status.stopped) {
    out.push({ value: status.value, label: status.name + ' (no longer used)', name: status.name, stopped: true, isDefault: false });
  }
  out.push({ value: NO_TAX, label: NO_TAX_LABEL, name: NO_TAX_LABEL, stopped: false, isDefault: false });
  return out;
}

// ── changing a line ──────────────────────────────────────────────────────────────────────────

function withoutSalesTax(line) {
  var out = Object.assign({}, line || {});
  delete out.salesTaxCodeId;
  delete out.salesTaxSnapshot;
  return out;
}

/**
 * The line with a new picker value. A stopped code can't be picked unless the line already has
 * it (then nothing changes). Picking the code the line already has keeps its copy (a re-save
 * never re-prices). Returns a NEW line; the input is not changed. Unknown value → the line as is.
 */
function applyLineTax(line, value, codes) {
  var l = line || {};
  if (value === NO_TAX) {
    var ex = withoutSalesTax(l);
    ex.taxExempt = true;
    return ex;
  }
  var code = namedCodeById(codes, value);
  if (!code) return Object.assign({}, l);
  if (code.stopped === true && l.salesTaxCodeId !== code.id) return Object.assign({}, l);
  var out = Object.assign({}, l);
  out.taxExempt = false;
  out.salesTaxCodeId = code.id;
  out.salesTaxSnapshot = snapshotFits(l, code.id) ? l.salesTaxSnapshot : salesTaxSnapshotOf(code);
  return out;
}

/**
 * The tax fields a NEW line starts with: a catalog item ticked Tax Exempt → No tax; the item's own
 * code if it has one still in use; else the company's default code. (No codes → { taxExempt: false }.)
 */
function newLineTaxFields(codes, catalogItem) {
  var item = catalogItem || {};
  if (item.taxExempt === true) return { taxExempt: true };
  var own = namedCodeById(codes, item.salesTaxCodeId);
  var code = own && own.stopped !== true ? own : defaultNamedCode(codes);
  if (!code) return { taxExempt: false };
  return { taxExempt: false, salesTaxCodeId: code.id, salesTaxSnapshot: salesTaxSnapshotOf(code) };
}

/**
 * At save (switch on): every taxed line ends with a code and its copy. An old line with no code
 * takes the default (what it was shown as); a line with a code but no fitting copy takes the
 * code's copy now. A line that already has a fitting copy is returned as the SAME object.
 * Exempt lines and non-objects pass through unchanged.
 */
function stampLineTax(line, codes) {
  if (line === null || typeof line !== 'object' || Array.isArray(line) || line.taxExempt === true) return line;
  var id = typeof line.salesTaxCodeId === 'string' ? line.salesTaxCodeId : '';
  if (id && snapshotFits(line, id)) return line;
  var code = id ? namedCodeById(codes, id) : defaultNamedCode(codes);
  if (!code) return line;
  var out = Object.assign({}, line);
  out.salesTaxCodeId = code.id;
  out.salesTaxSnapshot = salesTaxSnapshotOf(code);
  return out;
}

// ── what a CUSTOMER sees: one row per tax part (taxlines2-3e0b16a4, Stage S2) ─────────────────
// The server stores `taxParts` [{ key, name, rate, kind, taxable, amount }] beside `taxAmount` (and
// `approvedTaxParts` beside `approvedTaxAmount` on an approved estimate). Every customer output —
// PDFs, emails, the portal, the staff print page — asks customerTaxRows for its rows:
//   • rows only when the parts add up to the stored tax figure TO THE CENT; anything else (no parts,
//     a malformed part, parts left stale by an old editor) → null, and the caller shows today's single
//     tax row exactly as before. Stale parts never reach a customer.
//   • a part at 0% with $0.00 is hidden; if that leaves nothing → null (today's row, at $0.00), so the
//     tax line never disappears.
//   • each row has a `note`: null, or for a part the customer is exempt from (taxexempt3-8c4f2a1d)
//     "exempt #1234567890" — shown as "GST 5% — exempt #1234567890  $0.00" (taxRowText).
var TAX_ROWS_MARKER = 'taxlines2-3e0b16a4';

/** A stored money/rate figure: a finite number, else null. */
function storedTaxNumber(v) {
  return typeof v === 'number' && isFinite(v) ? v : null;
}

/**
 * A tax part's label for customers — the credit note's wording (creditNoteDocument.taxLabel), so an
 * invoice and its credit note read the same: QuickBooks' bookkeeping suffix dropped ("PST (BC) Sales"
 * → "PST (BC)"), then the rate unless the name already says it. "GST" at 5 → "GST 5%".
 */
function taxPartLabel(p) {
  var name = String((p && p.name) || 'Tax').trim().replace(/\s+(Sales|Purchases)$/i, '');
  var r = p ? p.rate : 0;
  var rate = typeof r === 'number' && isFinite(r) ? r : (r !== null && r !== '' && isFinite(Number(r)) ? Number(r) : 0);
  return rate > 0 && name.indexOf(rate + '%') === -1 ? name + ' ' + rate + '%' : name;
}

/**
 * customerTaxRows(doc, which) → [{ label, name, rate, amount, note }] or null (= show today's row).
 * which: 'headline' (taxParts vs taxAmount, the default) | 'approved' (approvedTaxParts vs approvedTaxAmount).
 */
function customerTaxRows(doc, which) {
  if (!doc || typeof doc !== 'object') return null;
  var approved = which === 'approved';
  var parts = approved ? doc.approvedTaxParts : doc.taxParts;
  var figure = storedTaxNumber(approved ? doc.approvedTaxAmount : doc.taxAmount);
  if (!Array.isArray(parts) || parts.length === 0 || figure === null) return null;
  var cents = 0;
  var rows = [];
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i];
    if (!p || typeof p !== 'object' || typeof p.name !== 'string' || p.name.trim() === '') return null;
    var rate = storedTaxNumber(p.rate);
    var amount = storedTaxNumber(p.amount);
    if (rate === null || amount === null) return null;
    cents += Math.round(amount * 100);
    if (rate === 0 && Math.round(amount * 100) === 0) continue;
    var exNum = exemptNumberOf(p); // taxexempt3-8c4f2a1d — an exempted part: "exempt #1234567890" at $0.00
    rows.push({ label: taxPartLabel(p), name: p.name, rate: rate, amount: amount, note: exNum === null ? null : (exNum ? 'exempt #' + exNum : 'exempt') });
  }
  if (cents !== Math.round(figure * 100) || rows.length === 0) return null;
  return rows;
}

/**
 * The parts as the customer portal receives them: name, rate and amount only — never the engine's
 * working fields (key, kind, taxable). Not an array → null; any malformed part → null (the portal
 * then shows today's row, exactly as the PDF would).
 */
function portalTaxParts(parts) {
  if (!Array.isArray(parts)) return null;
  var out = [];
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i];
    if (!p || typeof p !== 'object' || typeof p.name !== 'string') return null;
    var rate = storedTaxNumber(p.rate);
    var amount = storedTaxNumber(p.amount);
    if (rate === null || amount === null) return null;
    var exNum = exemptNumberOf(p);
    out.push(exNum === null ? { name: p.name, rate: rate, amount: amount } : { name: p.name, rate: rate, amount: amount, exemptNumber: exNum }); // taxexempt3-8c4f2a1d
  }
  return out;
}

/** A tax row as one line of text: "GST 5%", or "GST 5% — exempt #1234567890" for an exempted part. */
function taxRowText(row) {
  return row && row.note ? row.label + ' — ' + row.note : (row ? row.label : '');
}

// ── customer tax exemption (taxexempt3-8c4f2a1d, Stage S3) ───────────────────────────────────
// On the customer: taxExemption { parts: [the company's own tax part names], number, … }, written
// ONLY by the server (setCustomerTaxExemption). The engine leaves those parts off the customer's
// documents and keeps each as a $0.00 row (exempt: { number }). On one document, office staff can
// switch it off: taxExemptionOff { by, byName, at, reason, carriedFrom? } (setDocumentTaxExemption).
// THE SWITCH: `exemptionsEnabled` on settings/taxCodes (server-only). It counts only when Settings ›
// Taxes is on too. Missing = the test company only, so nothing changes anywhere else until a script
// sets it.
var TAX_EXEMPTION_MARKER = 'taxexempt3-8c4f2a1d';
var EXEMPTION_NUMBER_MAX = 40;
var EXEMPTION_REASON_MAX = 300;

/** Are customer tax exemptions on for this company? (Settings › Taxes must be on as well.) */
function exemptionsSwitchOn(orgId, taxCodesDoc) {
  if (!taxCodesSwitchOn(orgId, taxCodesDoc)) return false;
  var d = taxCodesDoc;
  if (d && typeof d === 'object' && typeof d.exemptionsEnabled === 'boolean') return d.exemptionsEnabled;
  return typeof orgId === 'string' && LEGACY_TAX_CODES_ORG_IDS.indexOf(orgId) !== -1;
}

/** An exemption number as stored: trimmed, inner spaces collapsed, no control characters; '' if empty or too long. */
function cleanExemptionNumber(v) {
  if (typeof v !== 'string') return '';
  var s = v.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().replace(/\s+/g, ' ');
  return s.length > 0 && s.length <= EXEMPTION_NUMBER_MAX ? s : '';
}

/** An exempted part's number: the engine's exempt.number, or the portal's exemptNumber; null = not exempted. */
function exemptNumberOf(p) {
  if (!p || typeof p !== 'object') return null;
  if (p.exempt && typeof p.exempt === 'object') return typeof p.exempt.number === 'string' ? p.exempt.number : '';
  return typeof p.exemptNumber === 'string' ? p.exemptNumber : null;
}

/** A part's name for people: QuickBooks' bookkeeping suffix dropped ("PST (BC) Sales" → "PST (BC)"). */
function taxPartDisplayName(name) {
  return String(name || '').trim().replace(/\s+(Sales|Purchases)$/i, '');
}

/**
 * The parts a customer can be exempted from: the company's OWN parts, by name — Settings › Taxes
 * codes for a company without QuickBooks, Spatchy's copy of its QuickBooks codes for one with it.
 * Parts at 0% are left out. One choice per name; label = "GST 5%" when the name has one rate, else
 * just the name.  → [{ name, label }]
 */
function exemptionPartChoices(taxCodesDoc, qbConnected) {
  var d = taxCodesDoc && typeof taxCodesDoc === 'object' ? taxCodesDoc : {};
  var codes = qbConnected
    ? (d.quickbooksCopy && Array.isArray(d.quickbooksCopy.codes) ? d.quickbooksCopy.codes.filter(function (c) { return c && c.active !== false; }) : [])
    : (savedTaxCodes(d) || []);
  var byName = {};
  var order = [];
  codes.forEach(function (c) {
    (c && Array.isArray(c.parts) ? c.parts : []).forEach(function (p) {
      var name = p && typeof p.name === 'string' ? p.name.trim() : '';
      var rate = Number(p && p.rate);
      if (!name || !(rate > 0)) return;
      var k = normTaxPartName(name);
      if (!byName[k]) { byName[k] = { name: name, rates: [] }; order.push(k); }
      if (byName[k].rates.indexOf(rate) === -1) byName[k].rates.push(rate);
    });
  });
  return order.map(function (k) {
    var e = byName[k];
    return { name: e.name, label: e.rates.length === 1 ? taxPartLabel({ name: e.name, rate: e.rates[0] }) : taxPartDisplayName(e.name) };
  });
}

/** The customer's exemption as the engine takes it — { parts, number } — or null (none, or not valid). */
function customerExemptionOf(customer) {
  var x = customer && customer.taxExemption;
  if (!x || typeof x !== 'object' || !Array.isArray(x.parts)) return null;
  var parts = x.parts.filter(function (n) { return typeof n === 'string' && n.trim() !== ''; });
  var number = cleanExemptionNumber(x.number);
  if (!parts.length || !number) return null;
  return { parts: parts, number: number };
}

/** "GST", "GST and PST", "GST, PST and QST". */
function exemptionPartsText(names) {
  var list = (Array.isArray(names) ? names : []).map(taxPartDisplayName).filter(Boolean);
  if (list.length <= 1) return list.join('');
  return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
}

/** A document's switch-off when it counts (the engine's rule: who, when and why all present), else null. */
function taxExemptionOffOf(doc) {
  var off = doc && doc.taxExemptionOff;
  if (!off || typeof off !== 'object') return null;
  if (!String(off.by || '').trim() || !off.at || !String(off.reason || '').trim()) return null;
  return off;
}

/**
 * What a staff screen shows about the exemption on an estimate or invoice, from the DOCUMENT itself
 * (never the customer's current setting): { kind: 'off', off } when switched off; { kind: 'applied',
 * parts, number } when its stored tax rows include exempted parts that add up; else null.
 */
function documentExemptionState(doc) {
  var off = taxExemptionOffOf(doc);
  if (off) return { kind: 'off', off: off };
  var rows = customerTaxRows(doc, 'headline');
  var parts = (doc && Array.isArray(doc.taxParts) ? doc.taxParts : []).filter(function (p) { return exemptNumberOf(p) !== null; });
  if (!rows || !parts.length) return null;
  return { kind: 'applied', parts: parts.map(function (p) { return p.name; }), number: exemptNumberOf(parts[0]) || '' };
}

/** The same for a job (jobs carry no tax rows): from the customer's exemption, unless switched off on the job. */
function jobExemptionState(job, customer) {
  var off = taxExemptionOffOf(job);
  if (off) return { kind: 'off', off: off };
  var ex = customerExemptionOf(customer);
  return ex ? { kind: 'job', parts: ex.parts, number: ex.number } : null;
}

/**
 * The banner's words. dateText = the switch-off date as the screen formats it ("Oct 30").
 *   applied → "This customer is exempt from GST (#123). It isn’t charged on this document."
 *   job     → "This customer is exempt from GST (#123). It won’t be charged when this job is invoiced."
 *   off     → "Exemption switched off for this document by Sierra, Oct 30 — “reason”" (+ carried from)
 */
function exemptionBannerText(state, dateText) {
  if (!state) return '';
  if (state.kind === 'off') {
    var o = state.off || {};
    var who = String(o.byName || '').trim() || 'a staff member';
    var when = dateText ? ', ' + dateText : '';
    var from = o.carriedFrom && o.carriedFrom.label ? ' (carried from ' + o.carriedFrom.label + ')' : '';
    return 'Exemption switched off for this document by ' + who + when + ' — “' + String(o.reason || '').trim() + '”' + from;
  }
  var head = 'This customer is exempt from ' + exemptionPartsText(state.parts) + (state.number ? ' (#' + state.number + ')' : '') + '.';
  return state.kind === 'job' ? head + ' It won’t be charged when this job is invoiced.' : head + ' It isn’t charged on this document.';
}

// ── the field-added marker (taxpick4-54573069, Stage S4) ─────────────────────────────────────
// Technicians get no tax picker anywhere. A line one adds on site takes the catalog item's code (else
// the company default) and carries taxCheck: { reason: 'field', at } — NO user id (who added the line
// is already on it, and a customer can read a raw estimate through the portal). Office editors show
// FIELD_TAX_CHECK_TEXT on that line until an office role (Owner, Admin, Manager, Office Staff) saves
// the document; anyone else's save keeps it. This file holds no role lists: the caller says whether
// the person saving is an office role.
var TAX_PICK_MARKER = 'taxpick4-54573069';
var FIELD_TAX_CHECK_TEXT = 'Added in the field — check tax';

/** Does this line carry the "added in the field — check tax" marker? */
function fieldTaxCheckOf(line) {
  var c = line && typeof line === 'object' ? line.taxCheck : null;
  return !!(c && typeof c === 'object' && c.reason === 'field');
}

/** The marker a technician's new line gets (atMs = milliseconds). Set only on lines a technician adds. */
function fieldTaxCheckMark(atMs) {
  return { reason: 'field', at: typeof atMs === 'number' && isFinite(atMs) ? atMs : 0 };
}

/** How many lines carry the marker. */
function fieldTaxCheckCount(lines) {
  return (Array.isArray(lines) ? lines : []).filter(fieldTaxCheckOf).length;
}

/**
 * The lines as an office role's save leaves them: every marker removed. isOfficeRole !== true → the
 * SAME array back (a Sales Consultant's or technician's save keeps the markers). Lines without a
 * marker are returned as the same objects; nothing marked → the same array.
 */
function clearFieldTaxCheck(lines, isOfficeRole) {
  if (!Array.isArray(lines) || isOfficeRole !== true) return lines;
  var changed = false;
  var out = lines.map(function (l) {
    if (!fieldTaxCheckOf(l)) return l;
    changed = true;
    var c = Object.assign({}, l);
    delete c.taxCheck;
    return c;
  });
  return changed ? out : lines;
}
// LINETAX-BODY-END

export { LINE_TAX_MARKER, NO_TAX, NO_TAX_LABEL, STOPPED_NOTE, LEGACY_TAX_CODES_ORG_IDS, taxCodesSwitchOn, savedTaxCodes, normTaxPartName, taxPartKey, namedCodeById, defaultNamedCode, salesTaxSnapshotOf, lineTaxStatus, lineTaxChoices, applyLineTax, newLineTaxFields, stampLineTax, TAX_ROWS_MARKER, taxPartLabel, customerTaxRows, portalTaxParts, taxRowText, TAX_EXEMPTION_MARKER, EXEMPTION_NUMBER_MAX, EXEMPTION_REASON_MAX, exemptionsSwitchOn, cleanExemptionNumber, exemptNumberOf, taxPartDisplayName, exemptionPartChoices, customerExemptionOf, exemptionPartsText, taxExemptionOffOf, documentExemptionState, jobExemptionState, exemptionBannerText, TAX_PICK_MARKER, FIELD_TAX_CHECK_TEXT, fieldTaxCheckOf, fieldTaxCheckMark, fieldTaxCheckCount, clearFieldTaxCheck };
